import React from 'react';
import { Card, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Avatar, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { formatDate } from '../../../../utils/dashboardFormatters';
import { useNavigate } from 'react-router-dom';

const TableCard = styled(Card)(({ theme }) => ({
  backgroundColor: '#ffffff',
  borderRadius: '8px',
  padding: '16px',
  boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1)',
  border: '1px solid #f0f0f0',
  flex: 1,
  minHeight: '400px'
}));

const TableTitle = styled(Typography)(({ theme }) => ({
  fontFamily: 'Inter, sans-serif',
  fontSize: '16px',
  fontWeight: 600,
  color: '#121927',
  marginBottom: '16px'
}));

const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  borderRadius: '4px',
  border: '1px solid #f0f0f0'
}));

const StyledTableHead = styled(TableHead)(({ theme }) => ({
  backgroundColor: '#0b91d6'
}));

const HeaderCell = styled(TableCell)(({ theme }) => ({
  fontFamily: 'Inter, sans-serif',
  fontSize: '16px',
  fontWeight: 500,
  color: '#ffffff',
  padding: '12px 16px',
  borderRight: '1px solid rgba(255, 255, 255, 0.2)',
  '&:last-child': {
    borderRight: 'none'
  }
}));

const DataCell = styled(TableCell)(({ theme }) => ({
  fontFamily: 'Inter, sans-serif',
  fontSize: '12px',
  fontWeight: 400,
  color: '#0b91d6',
  padding: '12px 16px',
  borderBottom: '1px solid #f0f0f0',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
}));
const UpcomingMeetingsTable = ({ data = [] }) => {
  const meetings = Array.isArray(data) ? data : [];
  const navigate = useNavigate();

  const renderClientName = (m) => {
    const lead = m.lead || m.leadDetails || m.lead_details || {};
    const clientDetails = m.clientDetails || m.client_details || m.client || {};
    const userDetails = m.userDetails || m.user_details || {};
    return (
      m.clientName || m.client_name || m.profileName || m.profile_name ||
      lead.business_name || clientDetails.full_name || userDetails.full_name || clientDetails.name ||
      (m.client && (m.client.name || m.client.full_name)) || 'Client'
    );
  };

  const renderDate = (m) => {
    const dateVal = m.date || m.date_time || m.meetingDate || m.meeting_date || m.start_date || m.created_at || m.createdAt || m.updatedAt || null;
    return formatDate(dateVal);
  };

  const renderTime = (m) => {
    const timeVal = m.meetingTime || m.meeting_time || m.start_time || m.time || m.date || m.date_time || null;
    return formatDate(timeVal);
  };

  const renderStatus = (m) => {
    const raw = m.status || m.meeting_status || m.meetingStatus || 'Scheduled';
    const s = String(raw).toLowerCase();
    if (s === 'completed' || s === 'completed' || s === '1' || s === 'true' || s === 'closed_won' || s === 'closed_won') return 'COMPLETED';
    if (s === 'reschedule' || s === 'rescheduled') return 'RESCHEDULE';
    if (s === 'not available' || s === 'not_available') return 'NOT AVAILABLE';
    if (s === 'not interested' || s === 'not_interested') return 'NOT INTERESTED';
    if (s === 'scheduled') return 'Scheduled';
    return String(raw).toUpperCase();
  };

  const handleRowClick = (m) => {
    const id = m.id || m.meeting_id || m._id || m.uuid;
    if (id) navigate(`/admin-dashboard/meeting/${id}`);
  };

  return (
    <TableCard sx={{ cursor: meetings.length ? 'pointer' : 'default' }}>
      <TableTitle>Upcoming Meetings</TableTitle>
      <StyledTableContainer>
        <Table size="small">
          <StyledTableHead>
            <TableRow>
              <HeaderCell>Client</HeaderCell>
              <HeaderCell>Date</HeaderCell>
              <HeaderCell>Time</HeaderCell>
              <HeaderCell align="right">Status</HeaderCell>
            </TableRow>
          </StyledTableHead>
          <TableBody>
            {meetings.length === 0 && (
              <TableRow>
                <DataCell colSpan={4}>No upcoming meetings</DataCell>
              </TableRow>
            )}
            {meetings.slice(0, 8).map((m, idx) => (
              <TableRow key={idx} hover sx={{ '&:hover': { background: '#f5fbff' } }} onClick={() => handleRowClick(m)}>
                <DataCell title={renderClientName(m)}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Avatar sx={{ width: 28, height: 28, bgcolor: '#e6f4ff', color: '#0b91d6', fontSize: 13 }}>{String(renderClientName(m)).charAt(0) || 'C'}</Avatar>
                    <Typography sx={{ fontWeight: 600, fontSize: 13, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{renderClientName(m)}</Typography>
                  </Box>
                </DataCell>
                <DataCell>{renderDate(m)}</DataCell>
                <DataCell>{renderTime(m)}</DataCell>
                <DataCell align="right">
                  <Typography sx={{ color: '#0b91d6', fontWeight: 600 }}>{renderStatus(m)}</Typography>
                </DataCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </StyledTableContainer>
    </TableCard>
  );
};

export default UpcomingMeetingsTable;